import Modal from "@/common/elements/Modal";
import { StyledGridCol, StyledGridRow, StyledFlex } from "@/common/styles";
import QuickSearchBookings from "@/components/SearchForms/QuickSearchBookings";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import {
  buildLineUpWhereClauseStructure,
  getOptionsFromRefList,
  isNonEmptyVariable,
} from "@/util/common_function";
import { Form, message } from "antd";
import Select from "@/common/elements/InputElements/Select";
import dayjs from "dayjs";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { useEffect, useState } from "react";
import Button from "@/common/elements/Button";
import { MODULES_LIST } from "@/util/common_variable";
import { useDispatch } from "react-redux";
import { setWhereClause } from "@/slices/lineupsSlice";
import useDialog from "@/hooks/useDialog";

const BookingsFilter = ({
  data = null,
  isFindModalVisible,
  setIsFindModalVisible,
  onHandleCancel,
  setReportListData,
  setReportListTotal,
  setBookingSearchPayload,
  setPagination,
  setIsFiltered,
  apiModule = MODULES_LIST.BOOKINGS,
  path = MODULES_LIST.STAFF,
  resetSignal,
}) => {
  const dispatch = useDispatch();
  const { showDialog } = useDialog();
  const [searchForm] = Form.useForm();
  const [isLoading, setIsloading] = useState(false);

  useEffect(() => {
    searchForm.resetFields();
  }, [isFindModalVisible]);

  useEffect(() => {
    if (resetSignal) {
      searchForm.resetFields();
    }
  }, [resetSignal]);

  useEffect(() => {
    if (isNonEmptyVariable(data)) {
      searchForm.setFieldsValue({
        ...data,
        heightPlusOrMinus: 2,
        weightPlusOrMinus: 5,
        agePlusOrMinus: 2,
        imageType: "Mug-Front",
      });
    }
  }, [data]);

  const fetchSearchResults = async () => {
    try {
      const values = await searchForm.validateFields();
      const filteredEntries = Object.entries(values).filter(([key, value]) => {
        if (dayjs.isDayjs(value)) {
          return value;
        }
        return value !== undefined && value !== null && value !== "";
      });
      const mapPayload = filteredEntries.map(([key, value]) => {
        const formattedValue = dayjs.isDayjs(value)
          ? value.format("MM/DD/YYYY")
          : value;

        if (
          [
            "height",
            "weight",
            "ageAtEntry",
            "heightPlusOrMinus",
            "weightPlusOrMinus",
            "agePlusOrMinus",
          ].includes(key)
        ) {
          return { filterKey: key, value: Number(value) };
        }

        if (key === "juvenile") {
          if (value === "No Juveniles") {
            return { filterKey: key, value: 0 };
          } else if (value === "Only Juveniles") {
            return { filterKey: key, value: 1 };
          }
          // return null;
        }

        return { filterKey: key, value: formattedValue };
      });

      const isActiveItem = mapPayload.find(
        (item) => item.filterKey === "isActive",
      );
      let payload;
      if (apiModule == MODULES_LIST.STAFF) {
        payload = [
          ...mapPayload.filter((item) => item.filterKey !== "isActive"),
          {
            filterKey: "isActive",
            value: isActiveItem ? !isActiveItem.value : true,
          },
        ];
      } else {
        payload = mapPayload;
      }

      if (path !== MODULES_LIST.LINEUPS) setBookingSearchPayload(payload);
      let url = API_ENDPOINTS.bookingsSearch + "?size=100&direction=desc";
      if (apiModule == MODULES_LIST.STAFF) {
        url = API_ENDPOINTS.staff.searchStaff + "?size=100&direction=desc";
      } else if (apiModule === MODULES_LIST.LINEUPS) {
        url = API_ENDPOINTS.lineups.listPhotos + "?size=100&direction=asc";
        const lineupWhereClause = buildLineUpWhereClauseStructure(payload);
        dispatch(setWhereClause(lineupWhereClause));
      }
      const response = await api.post(url, payload);

      return response.data;
    } catch (err) {
      console.log(err);
      return null;
    }
  };

  const onHandelFindGo = async (action) => {
    try {
      setIsloading(true);

      if (path !== MODULES_LIST.LINEUPS)
        setPagination({
          pageIndex: 0,
          pageSize: 100,
        });

      const data = await fetchSearchResults();
      if (!isFindModalVisible && !isNonEmptyVariable(data)) {
        return;
      }

      if (isNonEmptyVariable(data)) {
        if (action === "count") {
          showDialog("info", {
            title: "Count",
            content: `${data?.filteredRecords?.total} records found`,
            confirmButtonText: "Ok",
          });
          return;
        }
        if (apiModule == MODULES_LIST.STAFF) {
          let rowData = data.rows;
          if (isNonEmptyVariable(rowData)) {
            let rowData2 = rowData.map((a, i) => {
              let obj = {};
              obj.staffId = a.staffID;
              obj.name = a?.name;
              obj.badgeNumber = a?.badgeNumber;
              obj.rank = a?.rank;
              obj.division = a?.division;
              obj.username = a.username;
              obj.agency = a?.agency;
              return obj;
            });

            // setBookingSearchPayload([
            //   { filterKey: "searchType", value: "Starts With" },
            // ]);
            setReportListData((prev) => ({
              ...prev,
              rows: rowData2,
            }));
            setReportListTotal(data?.total);
            setIsFiltered(true);
          }
        } else if (apiModule === MODULES_LIST.LINEUPS) {
          const aldata = data?.filteredRecords?.rows?.map((r) => {
            return {
              ...r,
              visited: false,
            };
          });
          setReportListData(() => aldata);
          setReportListTotal(data?.totalRecords);
        } else {
          setReportListData(() => data?.rows);
          setReportListTotal(data?.total);
          setIsFiltered(true);
        }
        setIsFindModalVisible(false);
      }

      message.success("Search completed successfully");
    } catch (err) {
      console.log(err);
      setReportListData([]);
      message.error("Search failed");
    } finally {
      setIsloading(false);
    }
  };

  return (
    <Modal
      show={isFindModalVisible}
      size="lg"
      width="62%"
      header="Quick Search"
      designPattern="ant"
      maskClosable={false}
      onHide={onHandleCancel}
      handleCancel={onHandleCancel}
      footerActionsNeed={false}
    >
      <Form
        form={searchForm}
        layout="vertical"
        initialValues={{ searchType: "Starts With" }}
      >
        <QuickSearchBookings path={path} />
        <StyledGridRow
          className="ant-modal-footer custom"
          justify="space-between"
        >
          <StyledGridCol>
            <FormItem label="Search Type" layout="horizontal" name="searchType">
              <Select
                options={getOptionsFromRefList("Search_Type")}
                style={{ minWidth: "148px" }}
              />
            </FormItem>
          </StyledGridCol>
          <StyledGridCol>
            <StyledFlex gap="10px">
              {path === MODULES_LIST.LINEUPS && (
                <Button
                  onClick={() => onHandelFindGo("count")}
                  loading={isLoading}
                >
                  Count
                </Button>
              )}

              <Button
                color="default"
                type="default"
                onClick={() => onHandelFindGo("go")}
                loading={isLoading}
              >
                Go
              </Button>
              <Button color="default" type="default" onClick={onHandleCancel}>
                Cancel
              </Button>
            </StyledFlex>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </Modal>
  );
};

export default BookingsFilter;
